import { Link, useParams } from "react-router-dom"
import { Thread } from "../../../types"
import { classNames } from "../../utils"
import InitialsAvatar from "../initials-avatar"
import Badges from "./badges"
import Time from "./time"
import { TAKEOVER_PREFIX } from "../../constants"
import If from "../if"

interface ConversationsListItemProps {
  thread: Thread
}

const ConversationsListItem = ({ thread }: ConversationsListItemProps) => {
  const { _id = "" } = useParams<{ _id: string }>() // Provide a default empty string

  const isCurrentThread = thread._id === _id

  const wrapperClassNames = classNames(
    isCurrentThread ? "text-white bg-purple-400" : "",
    "py-3 px-4 flex"
  )

  const textClassNames = classNames(
    isCurrentThread ? "text-white" : "text-gray-600",
    "truncate text-sm max-w-48"
  )

  const initials = `${thread.first_name[0]}${thread.last_name[0]}`

  let lastMessage = thread.messages[thread.messages.length - 1]

  if (lastMessage && lastMessage.message?.startsWith(TAKEOVER_PREFIX)) {
    lastMessage = {
      ...lastMessage,
      message: lastMessage.message.replace(TAKEOVER_PREFIX, "")
    }
  }

  return (
    <li key={thread._id}>
      <Link to={`/conversations/${thread._id}`} className={wrapperClassNames}>
        <div className="flex flex-1">
          <InitialsAvatar
            initials={initials}
            size={8}
            isActive={isCurrentThread}
          />
          <div className="ml-3 mx-auto max-w-sm w-full">
            <div className="flex justify-between items-baseline">
              <strong className="font-semibold truncate max-w-48">
                {thread.first_name} {thread.last_name}
              </strong>
              <Time
                timestamp={
                  lastMessage?.message
                    ? lastMessage.timestamp
                    : thread.updatedAt
                }
              />
            </div>
            <div className="flex items-center justify-between">
              {lastMessage && (
                <p className={textClassNames}>{lastMessage.message}</p>
              )}
              <If
                condition={!!thread.hasNewMessages}
                then={
                  <span className="scale-[2.5] text-red-400">
                    •<i className="sr-only">new messages</i>
                  </span>
                }
              />
            </div>
            <Badges thread={thread} />
          </div>
        </div>
      </Link>
    </li>
  )
}

export default ConversationsListItem
